export default "__VITE_ASSET__AMVmhfod__"